export enum AssetEventType {
  Exclusive = "EXCLUSIVE",
  MovieNight = "MOVIE_NIGHT",
  ScheduledLive = "SCHEDULED_LIVE",
  VideoPremiere = "VIDEO_PREMIERE",
}
